export const Loader = () => {
  return (
    <span
      className="spinner-border spinner-border-sm text-secondary"
      role="status"
      aria-hidden="true"
      style={{ fontSize: "0.75rem" }}
    ></span>
  );
};
